/** @sfdc-extension-file SNK */
import type { PreloadFallbackProps } from '@/lib/page-designer/preload-fallback-registry';
import { Skeleton } from '@/components/ui/skeleton';

// oxlint-disable-next-line react/only-export-components -- synchronous fallback discovery reads this metadata export
export const componentTypeIds = ['Layout.productCarousel'] as const;

export default function ProductCarouselPreloadFallback({ component }: PreloadFallbackProps) {
    const data = component.data as { title?: string } | undefined;

    return (
        <div
            data-slot="component-preload-fallback"
            data-component-type={component.typeId}
            className="section-container w-full animate-pulse py-6"
            aria-hidden="true">
            {data?.title ? <Skeleton className="h-8 w-64 md:h-9" /> : null}
            <div className="flex w-full gap-4 overflow-hidden py-6">
                {Array.from({ length: 5 }, (_, index) => (
                    <div key={index} className="w-[348px] shrink-0 md:w-[256px] 2xl:w-[288px]">
                        <Skeleton className="w-full aspect-[0.8/1]" />
                        <div className="space-y-2 pt-4">
                            <Skeleton className="h-4 w-full" />
                            <Skeleton className="h-4 w-3/4" />
                            <Skeleton className="h-5 w-16" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
